<mat-toolbar class="page-footer-toolbar flex-row flex-hide-gt-sm">
    <cn-slide-container class="slide-container" [slideData]="tabTitles" [displaySlides]="1">
        <ng-container *cnForItem="let eachTab; let eachTabIndex = index">
            <button mat-button *ngIf="!eachTab.conditional || (eachTab.conditional() | async)" class="inactive-tab" [class.active]="eachTabIndex === selectedTabIndex" (click)="changeTabTo(eachTabIndex)">
                {{ eachTab.transform ? (eachTab.transform() | async) : eachTab.title }}
            </button>
        </ng-container>
    </cn-slide-container>
</mat-toolbar>
<div class="wrapper">
    <div class="featured flex-column flex-row-gt-sm">
        <div class="bulletin-board section">
            <cn-bulletin-board [maxLength]="screenSize ? 100 : 50"></cn-bulletin-board>
        </div>
        <div class="up-next section">
            <div class="header flex-row flex-start-center">
                <span class="title">Up Next</span>
                <mat-icon class="help-icon" #tooltipNext="matTooltip" (click)="tooltipNext.toggle()" matTooltip="{{ 'UP-NEXT-HOVERTEXT' | language | async }}">help_outline</mat-icon>
            </div>
            <cn-content-card-wide *ngFor="let item of nextUp" class="content-card" [content]="item.content" [contentList]="item.contentList" [course]="item.course" (complete)="refreshNextUp()"></cn-content-card-wide>
            <div *ngIf="!nextUp.length" class="no-next">
                <div *ngIf="!loadingNextUp; else loading">
                    <div class="no-next-message">
                        You're all caught up! <span *ngIf="canAccessStore">Head to the marketplace to find more {{ 'COURSES' | language | async | lowercase }}.</span>
                    </div>
                    <a class="link" *ngIf="canAccessStore" routerLink="/marketplace">Go to Marketplace</a>
                </div>
                <ng-template #loading>
                    Loading... <mat-spinner diameter="25"></mat-spinner>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="course-wrapper section">
        <cn-course-display [courses]="ownedCourses" [subjects]="subjects" [subjectTypes]="subjectTypes" [order]="ownedOrder" [orderOptions]="ownedOrderOptions" [columns]="courseSlideOptions[screenSize]" [owned]="true">
            <div class="course-list-header flex-row flex-start-center">
                <span class="title">{{ 'COURSES' | language | async | titlecase }}</span>
                <mat-icon class="help-icon" #tooltipOwned="matTooltip" (click)="tooltipOwned.toggle()" matTooltip="All the {{ 'COURSES' | language | async | lowercase }} you have available to you will be placed into {{ 'YOUR_LIBRARY' | language | async | titlecase }}.  Click the {{ 'YOUR_LIBRARY' | language | async | titlecase }} icon to access it.">help_outline</mat-icon>
                <a class="link" routerLink="/library">View {{ 'YOUR_LIBRARY' | language | async | titlecase }}</a>
            </div>
        </cn-course-display>
    </div>
    <div class="widgets-wrapper flex-column flex-row-gt-sm">
        <div class="widgets section" *ngIf="widgetComponents.length > 0">
            <div class="header flex-row flex-start-center">
                <div class="title-wrapper flex-row flex-start-center">
                    <span class="title">Tools</span>
                    <mat-icon class="help-icon" #tooltipTools="matTooltip" (click)="tooltipTools.toggle()"
                        matTooltip="A selection of the tools you have access to will appear here, on your dashboard. Click on All Tools to see additional tools. Certain {{ 'COURSES' | language | async | lowercase }} come with tools. Once purchased, these tools will appear here.">help_outline</mat-icon>
                </div>
                <a class="link" routerLink="/tools">All Tools</a>
            </div>
            <mat-grid-list class="widget-list" [cols]="screenSize >= 1 ? (screenSize >= 2 && !(canAccessThinkDaily$ | async)! ? 3 : 2) : 1" [rowHeight]="(screenSize >= 2) ? 'fit' : '1:1'">
                <mat-grid-tile *ngFor="let item of widgetComponents" [colspan]="1" [rowspan]="1">
                    <div class="widget-display">
                        <ng-template *ngComponentOutlet="item.component"></ng-template>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="canAccessStore && (!widgetComponents || !widgetComponents.length || widgetComponents.length % 2 !== 0)" [colspan]="1" [rowspan]="1">
                    <div class="more-tools-wrapper">
                        <div class="more-tools flex-column flex-center-center">
                            <div>
                                More tools available with other {{ 'COURSES' | language | async | lowercase }}.
                            </div>
                            <a class="link" routerLink="/marketplace">Go to Marketplace</a>
                        </div>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
        </div>
        <div class="think-daily section" *ngIf="canAccessThinkDaily$ | async">
            <cn-think-daily-widget></cn-think-daily-widget>
        </div>
    </div>
    <div class="course-wrapper section" *ngIf="canAccessStore">
        <cn-course-display [courses]="premiumCourses" [subjects]="subjects" [subjectTypes]="subjectTypes" [order]="premiumOrder" [orderOptions]="premiumOrderOptions" [columns]="courseSlideOptions[screenSize]">
            <div class="course-list-header flex-row flex-start-center">
                <div class="course-list-header flex-row flex-start-center">
                    <span class="title">Contractor School - </span>
                    <span>{{ 'COURSES' | language | async | titlecase }} available in Marketplace</span>
                    <mat-icon class="help-icon" #tooltipPremium="matTooltip" (click)="tooltipPremium.toggle()"
                        matTooltip="Here you’ll find all the {{ 'COURSES' | language | async | lowercase }} that have turned struggling contractors into profitable contractors. These {{ 'COURSES' | language | async | lowercase }} have helped with finding and hiring the right people, sales systems, lead generation, production, service, appointment center, accounting and more. Purchased {{ 'COURSES' | language | async | lowercase }} are placed into {{ 'YOUR_LIBRARY' | language | async | titlecase }}.  You may view purchased {{ 'COURSES' | language | async | lowercase }} as many times and as often as you like.">
                        help_outline</mat-icon>
                </div>
                <a class="link" routerLink="/marketplace">Go to Marketplace</a>
            </div>
        </cn-course-display>
    </div>
</div>
